import manualInvoiceItem from "./manualInvoiceItem.component";
import manualInvoiceItemUrls from "./manualInvoiceItem.urls";
import ManualInvoiceItemTransforms from "./manualInvoiceItem.transforms";

const manualInvoiceItemModule = angular
  .module("app.components.manualInvoiceItem", [])
  .component("manualInvoiceItemPage", manualInvoiceItem)
  .service("ManualInvoiceItemTransforms", ManualInvoiceItemTransforms)
  .config(manualInvoiceItemUrls);

export default manualInvoiceItemModule;



// WEBPACK FOOTER //
// ./src/pages/manualInvoiceItem/manualInvoiceItem.module.js